import React from "react";
import Marquee from "../components/Marquee";
import { useSiteData } from "../context/SiteDataContext";
import { uniqueLabels } from "../lib/contentCollections";
import { getSection, sectionStyle } from "../lib/sectionStyles";

const AsSeenIn = () => {
  const { publications, siteSections } = useSiteData();
  const section = getSection(siteSections, "global", "global.publications", {
    eyebrow: "Section 03 - As Seen In",
    subtitle: "On the masthead, on the record.",
    content: { items: publications },
  });
  const strip = getSection(siteSections, "global", "global.seo-strip", {
    content: {
      items: ["Pitches welcome", "Cover stories", "Long-reads", "Profiles", "Edits", "Cultural commentary"],
    },
  });

  if (!section) return null;
  const rawItems = Array.isArray(section.content?.items) && section.content.items.length ? section.content.items : publications;
  const items = uniqueLabels(rawItems.map((item) => (typeof item === "string" ? item : item?.name)));
  const stripItems = uniqueLabels(strip?.content?.items);

  return (
    <section className="bg-[var(--ink)] text-[var(--paper)]" style={sectionStyle(section)}>
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-14">
        <div className="flex items-center justify-between border-b border-[var(--paper)]/30 pb-3 mb-8">
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--pink-soft)]/70">
            {section.eyebrow || "Section 03 - As Seen In"}
          </span>
          <span className="font-editorial italic text-[var(--pink-soft)]">
            {section.subtitle || "On the masthead, on the record."}
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-y-6 gap-x-4">
          {items.map((p, i) => (
            <div
              key={typeof p === "string" ? p : p.name || i}
              className="font-masthead tracking-[0.18em] text-2xl md:text-3xl border-b border-[var(--paper)]/20 pb-3 hover:text-[var(--pink)] transition-colors"
            >
              <span className="text-[var(--pink-soft)]/60 mr-2 text-sm align-middle">
                {String(i + 1).padStart(2, "0")}
              </span>
              {p}
            </div>
          ))}
        </div>
      </div>
      <Marquee items={stripItems} accent speed={28} />
    </section>
  );
};

export default AsSeenIn;
